/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DimensionDefinitionBatchResponse {
    getFixupPrototypeFunction() { return DimensionDefinitionBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<DimensionDefinitionBatchResponse>): DimensionDefinitionBatchResponse {
        let obj = Object.assign(new DimensionDefinitionBatchResponse(), model);
        DimensionDefinitionBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DimensionDefinitionBatchResponse>): DimensionDefinitionBatchResponse {
        if (!model) return null;
        return DimensionDefinitionBatchResponse.newInstance(<DimensionDefinitionBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DimensionDefinitionBatchResponse) {
        if (!obj) return;

        models.DimensionDefinitionBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DimensionDefinitionBatchResponse): boolean {
        Object.setPrototypeOf(obj, DimensionDefinitionBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.DimensionDefinition.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.DimensionDefinition; };

}
